@if(hasAccess() === true){
  <nav class="card" [ngClass]="navService.menuOpen() === true ? 'show' : 'hide'">
    <a
      routerLink="/rdata-aggregates"
      routerLinkActive="navlink--active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="navlink"
      (click)="navService.hide()"
    >
      <div class="nav-content nav-section rdata-aggregates">rData Aggregates</div>
    </a>
    <a
      routerLink="/rdata-records"
      routerLinkActive="navlink--active"
      class="navlink"
      (click)="navService.hide()"
    >
      <div class="nav-content nav-section rdata-records">rData Records</div>
    </a>
    <button class="navlink mobile-control" (click)="logout()">
      <div class="nav-content nav-section logout">Logout</div>
    </button>
  </nav>
}

<main>
  @if(hasAccess() === false){
    <app-no-access></app-no-access>
  }
  @else {
    <router-outlet></router-outlet>
  }
</main>
